module.exports = __webpack_public_path__ + "img/section2Left.db55abe9.webp";